// extracted by mini-css-extract-plugin
export default {"viewButton":"Tags-module--viewButton--6a965","icon":"Tags-module--icon--22ba2","pointer":"Tags-module--pointer--316ba"};